import { MeetingFormatTypes } from "src/store/proxy/types";

export const MEETING_FORMAT_LABEL: { [key in MeetingFormatTypes]: string } = {
  in_person: "In person",
  virtual: "Virtual",
  telephone: "Phone number",
  private: "Private",
};
